import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'

import change_centrum from '../components/icons/change_centrum.vue'
import pravnicka_osoba from '../components/icons/pravnicka_osoba.vue'
import podnikatel from '../components/icons/podnikatel.vue'
import spotrebitel from '../components/icons/spotrebitel.vue'
import detail_zmluvy from '../components/icons/detail_zmluvy.vue'
import copy from '../components/icons/copy.vue'
import edit from '../components/icons/edit.vue'
import trash from '../components/icons/trash.vue'
import avatar from '../components/icons/avatar.vue'
import check_circle from '../components/icons/check_circle.vue'
import full_screen from '../components/icons/full_screen.vue'
import produkt_porovnanie_balikov from '../components/icons/produkt_porovnanie_balikov.vue'

Vue.use(Vuetify)
import '@/styles/overrides.sass'

const darkTheme = {
  primary: '#0097FD',
  secondary: '#1A1B1F',
  accent: '#005b98',
  info: '#00CAE3',
  error: "#E14C4C",
  white: "#ffffff",
  black: "#000000"
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    dark: true,
    themes: {
      //dark: darkTheme,
      //light: lightTheme,
    },
  },
  icons: {
    values: {
      change_centrum: {
        component:change_centrum
      },
      forma_pravnicka: {
        component:pravnicka_osoba
      },
      forma_podnikatel: {
        component:podnikatel
      },
      forma_spotrebitel: {
        component:spotrebitel
      },
      detail_zmluvy: {
        component: detail_zmluvy
      },
      copy: {
        component: copy
      },
      edit: {
        component: edit
      },
      trash: {
        component: trash
      },
      avatar: {
        component: avatar
      },
      check_circle: {
        component: check_circle
      },
      full_screen: {
        component: full_screen
      },
      produkt_porovnanie_balikov:{
        component: produkt_porovnanie_balikov
      }

    },
  },
})
